import { render, staticRenderFns } from "./mall_coin.vue?vue&type=template&id=2ddaf81a&scoped=true"
import script from "./mall_coin.vue?vue&type=script&lang=ts"
export * from "./mall_coin.vue?vue&type=script&lang=ts"
import style0 from "./mall_coin.vue?vue&type=style&index=0&id=2ddaf81a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddaf81a",
  null
  
)

export default component.exports